export type NavigatorState = {
  learnerOutcome: string | null;
  competency: string | null;
  subCompetency: string | null;
  performanceLevel: string | null;
};

enum NavigatorActionType {
  SetLearnerOutcome = "SetLearnerOutcome",
  SetCompetency = "SetCompetency",
  SetSubCompetency = "SetSubCompetency",
  SetPerformanceLevel = "SetPerformanceLevel",
}

type SetLearnerOutcomeAction = {
  type: NavigatorActionType.SetLearnerOutcome;
  payload: { learnerOutcome: string | null };
};

type SetCompetencyAction = {
  type: NavigatorActionType.SetCompetency;
  payload: { competency: string | null };
};

type SetSubCompetencyAction = {
  type: NavigatorActionType.SetSubCompetency;
  payload: { subCompetency: string | null };
};

type SetPerformanceLevelAction = {
  type: NavigatorActionType.SetPerformanceLevel;
  payload: { performanceLevel: string | null };
};

export type NavigatorAction =
  | SetLearnerOutcomeAction
  | SetCompetencyAction
  | SetSubCompetencyAction
  | SetPerformanceLevelAction;

export const setLearnerOutcome = (
  learnerOutcome: string | null,
): SetLearnerOutcomeAction => ({
  type: NavigatorActionType.SetLearnerOutcome,
  payload: { learnerOutcome },
});

export const setCompetency = (
  competency: string | null,
): SetCompetencyAction => ({
  type: NavigatorActionType.SetCompetency,
  payload: { competency },
});

export const setSubCompetency = (
  subCompetency: string | null,
): SetSubCompetencyAction => ({
  type: NavigatorActionType.SetSubCompetency,
  payload: { subCompetency },
});

export const setPerformanceLevel = (
  performanceLevel: string | null,
): SetPerformanceLevelAction => ({
  type: NavigatorActionType.SetPerformanceLevel,
  payload: { performanceLevel },
});
export const initialState: NavigatorState = {
  learnerOutcome: null,
  competency: null,
  subCompetency: null,
  performanceLevel: null,
};

const navigationReducer = (
  state: NavigatorState,
  action: NavigatorAction,
): NavigatorState => {
  switch (action.type) {
    case NavigatorActionType.SetLearnerOutcome:
      return {
        learnerOutcome: action.payload.learnerOutcome,
        competency: null,
        subCompetency: null,
        performanceLevel: null,
      };
    case NavigatorActionType.SetCompetency:
      return {
        ...state,
        competency: action.payload.competency,
        subCompetency: null,
        performanceLevel: null,
      };
    case NavigatorActionType.SetSubCompetency:
      return {
        ...state,
        subCompetency: action.payload.subCompetency,
        performanceLevel: null,
      };
    case NavigatorActionType.SetPerformanceLevel:
      return {
        ...state,
        performanceLevel: action.payload.performanceLevel,
      };
    default:
      return state;
  }
};

export default navigationReducer;
